import items from './items';
import show from './show';
import store from './store';
import update from './update';
import updateRoundInvoiceTotal from './updateRoundInvoiceTotal';
import destroy from './destroy';
import archiveReport from './archiveReport';
import generateKID from './generateKID';
import validateKID from './validateKID';
import attachmentPdf from './attachmentPdf';
import markAsPaid from './markAsPaid';
import bulkMarkAsPaid from './bulkMarkAsPaid';
import payment from './payment';
import sendReminder from './sendReminder';
import sendReminderPreview from './sendReminderPreview';
import createReminder from './createReminder';

export default {
  items,
  store,
  destroy,
  show,
  update,
  updateRoundInvoiceTotal,
  archiveReport,
  generateKID,
  validateKID,
  attachmentPdf,
  markAsPaid,
  bulkMarkAsPaid,
  payment,
  sendReminder,
  sendReminderPreview,
  createReminder,
};



// WEBPACK FOOTER //
// ./src/app/services/bill/index.js